import { CapType, LendingVaultExpanded, useVaultMaxAmountFromCap } from "@bridgesplit/abf-react";

import { VaultCapsTableSummary } from "./type";

// Builds an array of each cap type.
export function useVaultCapsSummary({
    vaultExpanded
}: {
    vaultExpanded: LendingVaultExpanded | undefined;
}): VaultCapsTableSummary[] {
    const supplyCap = useVaultMaxAmountFromCap(vaultExpanded, CapType.Supply);
    const borrowCap = useVaultMaxAmountFromCap(vaultExpanded, CapType.Borrow);
    const withdrawCap = useVaultMaxAmountFromCap(vaultExpanded, CapType.Withdraw);

    if (!vaultExpanded) {
        return [];
    }

    const summary: VaultCapsTableSummary[] = [
        {
            id: "supply-summary",
            capType: CapType.Supply,
            last1hrPeriodStart: vaultExpanded.vaultStrategy.supplyCapMonitor.startTime1hr.toNumber() ?? undefined,
            last24hrPeriodStart: vaultExpanded.vaultStrategy.supplyCapMonitor.startTime24hr.toNumber() ?? undefined,
            max1hrAmount: vaultExpanded.vaultStrategy.terms.supplyCaps.max1hr?.toNumber() ?? null,
            max24hrAmount: vaultExpanded.vaultStrategy.terms.supplyCaps.max24hr?.toNumber() ?? null,
            live1hrAmount: supplyCap?.current1hrAmountRemaining?.toNumber() ?? null,
            live24hrAmount: supplyCap?.current24hrAmountRemaining?.toNumber() ?? null
        },
        {
            id: "borrow-summary",
            capType: CapType.Borrow,
            last1hrPeriodStart: vaultExpanded.vaultStrategy.borrowCapMonitor.startTime1hr.toNumber() ?? undefined,
            last24hrPeriodStart: vaultExpanded.vaultStrategy.borrowCapMonitor.startTime24hr.toNumber() ?? undefined,
            max1hrAmount: vaultExpanded.vaultStrategy.terms.borrowCaps.max1hr?.toNumber() ?? null,
            max24hrAmount: vaultExpanded.vaultStrategy.terms.borrowCaps.max24hr?.toNumber() ?? null,
            live1hrAmount: borrowCap?.current1hrAmountRemaining?.toNumber() ?? null,
            live24hrAmount: borrowCap?.current24hrAmountRemaining?.toNumber() ?? null
        },
        {
            id: "withdraw-summary",
            capType: CapType.Withdraw,
            last1hrPeriodStart: vaultExpanded.vaultStrategy.withdrawCapMonitor.startTime1hr.toNumber() ?? undefined,
            last24hrPeriodStart: vaultExpanded.vaultStrategy.withdrawCapMonitor.startTime24hr.toNumber() ?? undefined,
            max1hrAmount: vaultExpanded.vaultStrategy.terms.withdrawCaps.max1hr?.toNumber() ?? null,
            max24hrAmount: vaultExpanded.vaultStrategy.terms.withdrawCaps.max24hr?.toNumber() ?? null,
            live1hrAmount: withdrawCap?.current1hrAmountRemaining?.toNumber() ?? null,
            live24hrAmount: withdrawCap?.current24hrAmountRemaining?.toNumber() ?? null
        }
    ];

    return summary;
}
